import { render, staticRenderFns } from "./EditTournamentFront.vue?vue&type=template&id=46dddf21"
import script from "./EditTournamentFront.vue?vue&type=script&lang=js"
export * from "./EditTournamentFront.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports